import { React, useState } from 'react';
import {
    createStyles,
    Text,
    Avatar,
    Group,
    TypographyStylesProvider,
    Paper,
    Textarea,
    Button,
    Card,
    Table,
    Badge,
    ScrollArea,
    ActionIcon,
    Radio,
    Stack,
    Modal
} from '@mantine/core';
import{
    IconGavel,
    IconMessage,
    IconFileReport,
    IconArticle,
    IconNotes,
    IconEdit,
    IconCalendar
} from '@tabler/icons';
import { nanoid } from '@reduxjs/toolkit';
import koenigsegg from '../assets/koenigsegg.jpg';

import AuctionItemCreation from '../pages/AuctionItemCreation';



const useStyles = createStyles((theme) => ({
    tableContain: {
        width: "80%",
        overflowX: "auto",
        whiteSpace: "nowrap",
    },
    creationItem: {
        width: "60%"
    }
}));

let authHold = {
    src: koenigsegg,
    name: "John Does"
}


//descript:inventory list
//needed:time_remain and countdown functionality
let tempData = [
    {
        key: nanoid(),
        listingImg: koenigsegg,
        status: 'Active',
        title: '2008 Pagani Huayra',
        itemType: 'Car',
        highBid: '$950,000',
        views: '11,000',
        staff: 'Erik',
    },
    {
        key: nanoid(),
        listingImg: koenigsegg,
        status: 'Inactive',
        title: '2001 Toyota Supra',
        itemType: 'Boat',
        highBid: '$55,000',
        views: '1,000',
        staff: 'Tonya,Tanny,Abby',
    },
    {
        key: nanoid(),
        listingImg: koenigsegg,
        status: 'Active',
        title: '1969 Boss 429',
        itemType: 'Car',
        highBid: '$295,000',
        views: '225',
        staff: 'Ed,Mack,Mark',
    },
    {
        key: nanoid(),
        listingImg: koenigsegg,
        status: 'Draft',
        title: '1970 Boss 302',
        itemType: 'Car',
        highBid: '$295,000',
        views: '225',
        staff: 'Jack,Tom',
    },

]


//later:add search, filter, and sort functionality
//needed:put the table inside of cards
//needed: controls at the top
//needed: handle if the auctioneer hasnt created anything yet
//of_note: this cdan also be used for handing out leads
//descript: depending on how this goes....
// it should create stafflist(with controls), and subscriber list
//create a page foreach as well 

export function InventoryList() {
    const { classes } = useStyles();
    const [iListCtx, setIListCtx] = useState('inventory');
    const [detsOpened, setDetsOpened] = useState(false);
    
    //redo this flow to match the other parents
    const inventoryRows = tempData.map((row, index) => {
        //descript:assign coordinating color and status
        let statusColor = 'green';
        switch(row.status){
            case 'Active':
                statusColor = 'green';
                break;
            case 'Inactive':
                statusColor = 'red';
                break;
            case 'Draft':
                statusColor = 'yellow';
                break;
            default:
                statusColor = 'green';
        }
        return(
            <tr key={row.key} >
                <td>
                    <Avatar src={row.listingImg} alt={"listing preview image"}/>
                </td>
                <td>
                    <Badge
                        variant="filled"
                        color={statusColor}
                    >
                        {row.status}
                    </Badge>
                </td>
                <td>
                    <Text>
                        {row.title}
                    </Text>
                </td>
                <td>
                    <Text>
                        {row.itemType}
                    </Text>
                </td>
                <td>
                    <Text>
                        {row.highBid}
                    </Text>
                </td>
                <td>
                    <Text>
                        {row.views}
                    </Text>
                </td>
                <td>
                    <Text name="listings_staff">
                        {row.staff}
                    </Text>
                </td>
                <td>
                    <ActionIcon name="listings_edit" radius="lg" size="xl" variant="filled" color="blue">
                        <IconEdit id="saveDraft" size={36} stroke={2.0}/>
                    </ActionIcon>
                </td>
                <td>
                    <ActionIcon name="listings_schedule" radius="lg" size="xl" variant="filled" color="blue">
                        <IconCalendar size={36} stroke={2.0}/>
                    </ActionIcon>
                </td>
            </tr>
        );
    });


    return (
        <>
            <Stack align="center" justify="flex-start">
                <Button
                    className={classes.creationItem}
                    name="create_listing"
                    fullWidth
                    onClick={() => setDetsOpened(true)}
                    leftIcon={<IconGavel color={"white"} size={35} stroke={2.0}/>}
                    color={"green"}
                >
                Add Item
                </Button>
                <Radio.Group
                    value={iListCtx}
                    onChange={setIListCtx}
                    name="inventory"
                    label="Select the state of items to be shown"
                >
                    <Radio value="inventory" label="Inventory" />
                    <Radio value="sold" label="Sold" />
                    <Radio value="noReserve" label="No Reserve" />
                </Radio.Group>
                <br/>
                <div className={classes.tableContain}>
                    <Table
                        verticalSpacing="md"
                    >
                        <thead>
                            <tr>
                                <th>Preview</th>
                                <th>Status</th>
                                <th>Title</th>
                                <th>Category</th>
                                <th>High Bid</th>
                                <th>Views</th>
                                <th>Staff</th>
                                <th>Edit</th>
                                <th>Schedule</th>
                            </tr>
                        </thead>
                        <tbody>{inventoryRows}</tbody>
                    </Table>
                </div>
            </Stack>
            <Modal
                opened={detsOpened}
                returnFocus={true}
                fullScreen
                closeOnClickOutside={true}
                onClose={() => setDetsOpened(false)}
                overflow="inside"
            >
                <AuctionItemCreation/>
                
            </Modal>
            
        </>
    );
}
